<template>
  <div
    ref="library-episodes"
    class="library-episodes"
    data-test="library-episodes">
    <div
      v-if="isLoggedIn"
      class="container">
      <loader
        v-show="!episodes_loaded && !episodes.length"
        center
        label="Fetching Episodes ..."/>
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="top-bar">
        <p data-test="count-episode">{{ episodes.length }} Episode{{ episodes.length > 1 || !episodes.length ? 's' : '' }}</p>
        <div
          v-if="episodes.length"
          class="filter-select">
          <el-select
            v-model="filter_value"
            :clearable="true"
            :popper-append-to-body="false"
            placeholder="Sort By"
            @change="filterSelect"
            @clear="sortByPosition">
            <el-option
              v-for="elem in select_filters"
              :key="elem.val"
              :label="elem.name"
              :value="elem.val"/>
          </el-select>
        </div>
      </el-row>
      <!-- Empty Shows Box -->
      <empty-shows
        v-show="!episodes.length && episodes_loaded"
        option="playlist"/>
      <!-- Display Episodes-->
      <div
        v-if="episodes.length"
        class="draggable-container">
        <div class="placeholder-container">
          <div
            v-for="(item,index) in episodes"
            :key="index"
            :style="{'height': item.height+'px'}"
            class="single-placeholder">
            <div class="placeholder">
              <p>Release to drop item here.</p>
            </div>
          </div>
        </div>
        <SlickList
          v-model="episodes"
          :use-window-as-scroll-container="true"
          :use-drag-handle="true"
          lock-axis="y"
          data-test="list-episodes"
          @sortStart="onEpisodeSortStart($event)"
          @sortEnd="onEpisodeSortEnd($event)"
        >
          <SlickItem
            v-for="(item, index) in episodes"
            :key="index"
            :index="index"
            data-test="episode">
            <card-list
              :index="index"
              :shows="item"
              :podcast="item.season.podcast"
              :toggle-details="item.show_details"
              :draggable-icon="true"
              :is-exclusive="item.season && item.season.podcast && item.season.podcast.is_exclusive"
              :is-free="(item.season && item.season.podcast && item.season.podcast.is_exclusive) && !item.is_exclusive"
              :season_no="item.season && item.season.number"
              :episode_no="item.episode_number"
              :bucket="bucket"
              playlist-type="my-episodes"
              @deleted="deleteEpisode($event,index)"
              @details="resizePlaceholder"
            />
          </SlickItem>
        </SlickList>
        <loader
          v-show="episodes.length && !episodes_loaded && !no_more_episodes"
          :with-margin="true"/>
      </div>
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import { SlickList, SlickItem } from 'vue-slicksort';
import Episode from '../../services/Episode';
import User from '../../services/User';
import SegmentEvent from '../../services/PlayerEvent';
import CardList from '../../components/CardList';
import loader from '../../components/Loader';
import EmptyShows from '../../components/EmptyShows';
import ScrollMixin from '../../shared/scrollMixin';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'Shows',
  components: {
    loader,
    SlickList,
    SlickItem,
    'card-list': CardList,
    'empty-shows': EmptyShows,
  },
  mixins: [ScrollMixin, PageMixin],
  data() {
    return {
      pageName: 'My Playlist',
      episode_service: new Episode(),
      user_service: new User(),
      eventProvider: new SegmentEvent(),
      episodes: [],
      scroll_threshold: 500,
      isLoggedIn: this.$store.getters.loggedIn,
      page: 0,
      show_infinite_scroll: false,
      no_more_episodes: false,
      scroll_during_reordering: false,
      episodes_loaded: false,
      filter_value: null,
      show_placeholder: false,
      show_details: false,
      limit: 25,
      select_filters: [
        {
          name: 'Newest',
          val: 1,
          meth: () => {
            this.episodes.sort((a, b) => new Date(b.released_at) - new Date(a.released_at));
          },
        },
        {
          name: 'Oldest',
          val: 2,
          meth: () => {
            this.episodes.sort((a, b) => new Date(a.released_at) - new Date(b.released_at));
          },
        },
        {
          name: 'Shortest',
          val: 3,
          meth: () => {
            this.episodes.sort((a, b) => a.runtime - b.runtime);
          },
        },
        {
          name: 'Longest',
          val: 4,
          meth: () => {
            this.episodes.sort((a, b) => b.runtime - a.runtime);
          },
        },
      ],
      selected_filter_value: -1,
      bucket: {},
    };
  },
  beforeMount() {
    this.parentSelector = 'library-episodes';
    this.childSelector = '.library-episodes .show-card-list.is-visible';
  },
  updated() {
    this.resizePlaceholder();
  },
  mounted() {
    if (!this.isLoggedIn) return;
    this.getEpisodesFromLibrary();
    this.infiniteScrollPlaylist();
    this.bucket = {
      bucket_uuid: null,
      name: 'Episodes',
      bucket_type: 'episodes',
      position: 0,
      items_count: this.episodes.length,
      media_size: 'episode_details',
    };
  },
  beforeDestroy() {
    this.removeScrollEvent();
  },
  methods: {
    getEpisodesFromLibrary() {
      this.episodes_loaded = false;
      if (this.no_more_episodes) {
        this.episodes_loaded = true;
        return;
      }
      this.page++;
      this.show_infinite_scroll = true;
      this.episode_service.getEpisodesFromLibrary(this.limit, this.page)
        .then((tempEpisodes) => {
          if (tempEpisodes.length < 25) {
            this.no_more_episodes = true;
            this.show_infinite_scroll = false;
            this.episodes_loaded = true;
          }
          if (!tempEpisodes.length) return;
          this.mapEpisodes(tempEpisodes);
          if (this.selected_filter_value !== -1) {
            Object.call(this.select_filters[this.selected_filter_value - 1].meth());
          } else {
            this.sortByPosition();
          }
          this.episodes_loaded = true;
          this.show_infinite_scroll = false;
          this.$store.dispatch('setPlaylist', this.episodes);
        })
        .catch((err) => {
          log.error(err.message);
          this.no_more_episodes = true;
          this.show_infinite_scroll = false;
          this.episodes_loaded = true;
        });
    },
    mapEpisodes(episodes) {
      // progress: item.episode.episode_listen ? item.episode.episode_listen.elapsed : 0,
      // total_runtime: item.episode.episode_listen ? item.episode.episode_listen.runtime : 0,
      // show_details: false,
      episodes.forEach((item) => {
        this.episodes.push({
          ...item.episode,
          progress: 0,
          record_id: item.uuid,
          position: item.position,
          display_image_url: item.episode.display_image_url || item.episode.season.podcast.display_image_url,
          image_url: item.episode.display_image_url || item.episode.season.podcast.display_image_url,
          in_library: true,
          height: 170,
          toggleDraggable: false,
        });
      });
      this.contentList = this.episodes;
    },
    infiniteScrollPlaylist() {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
      document.getElementsByTagName('body')[0].addEventListener('scroll', this.infiniteScrollPlaylistCallback);
    },
    infiniteScrollPlaylistCallback() {
      const heightLimit = document.body.scrollTop + window.innerHeight + this.scroll_threshold >= document.body.scrollHeight;
      if (heightLimit && this.episodes_loaded) {
        this.getEpisodesFromLibrary();
      }
    },
    resizePlaceholder() {
      // Resize Placeholders
      try {
        const elem = document.querySelectorAll('.draggable-container .show-card-list');
        if (!elem || !elem.length) {
          return;
        }
        for (let i = 0; i < elem.length; i++) {
          this.episodes[i].height = elem[i].clientHeight;
        }
      } catch (ex) {
        // console.log(`Exception: ${ex.message}`);
      }
    },
    onEpisodeSortStart() {
      // this.hideDetails();
      this.resizePlaceholder();
      this.scroll_during_reordering = true;
      this.resizeEpisodeCardList();
    },
    onEpisodeSortEnd(event) {
      this.episodes[event.oldIndex].toggleDraggable = false;
      this.resizePlaceholder();
      this.scroll_during_reordering = false;
      document.querySelector('body').classList.remove('move-cursor');
      if (event.oldIndex !== event.newIndex) {
        this.updateEpisodePosition(this.episodes[event.oldIndex], event.newIndex + 1);
      }
    },
    resizeEpisodeCardList() {
      // A cloned element is made at the very end of body tag.
      // Resize Chosen Element
      const screenWidth = window.innerWidth;
      document.querySelector('body').classList.add('move-cursor');
      const parentElement = document.body.lastElementChild.children[0];
      parentElement.classList.add('b-t-0', 'bg-transparent');
      parentElement.children[0].classList.add('d-flex');
      parentElement.children[1].classList.add('d-none');
      if (screenWidth <= 375) {
        parentElement.children[0].classList.add('w-95');
      }
    },
    hideDetails() {
      this.episodes.forEach((item) => { item.show_details = false; });
    },
    sortByPosition() {
      this.episodes.sort((a, b) => a.position - b.position);
    },
    deleteEpisode(id, index) {
      if (!id) return;
      this.episodes.splice(index, 1);
    },
    updateEpisodePosition(userEpisode, pos) {
      this.episode_service.updateEpisodePosition(userEpisode.record_id, pos)
        .then((res) => {
          if (res && res.success) this.eventProvider.triggerEpisodeReorderEvent(userEpisode.uuid, res.new_position, res.position);
        })
        .catch((err) => { log.warn(err.message); });
    },
    filterSelect(val) {
      this.selected_filter_value = val;
      const ind = this.select_filters.findIndex(elem => this.filter_value === elem.val);
      if (ind > -1) Object.call(this.select_filters[ind].meth());
      log.info(this.episodes);
    },
    removeScrollEvent() {
      const body = document.getElementsByTagName('body')[0];
      body.style = {};
      document.getElementsByTagName('body')[0].removeEventListener('scroll', this.infiniteScrollPlaylistCallback);
    },
  },
};
</script>
<style lang="scss">
@import '../../assets/scss/variables.scss';
.el-select-dropdown__item {
  height: 30px !important;
  line-height: 30px !important;
}
.library-episodes {
  .container {
    .top-bar {
      margin: 35px 62px;
      >p {
        font-size: 24px;
        color: $black;
      }
    }
    .filter-select {
      .el-select {
        width: 130px;
        cursor: pointer;
        .el-input {
          .el-input__inner {
            border-radius: 20px !important;
            color: $black !important;
            border: 1px solid $black !important;
            font-weight: 500 !important;
            padding: 5px 15px 5px 30px;
            font-size: 14px !important;
            line-height: 20px !important;
            height: 32px !important;
          }
          .el-input__inner::placeholder {
            overflow: visible;
            color: $black !important;
          }
          .el-input__suffix {
            i {
              font-size: 10px;
              color: $black !important;
              line-height: 0 !important;
            }
          }
        }
      }
      .el-select::before {
        content: "";
        position: absolute;
        display: block;
        top: 11px;
        left: 11px;
        background-size: contain;
        z-index: 1;
        width: 15px;
        height: 15px;
        background: url(../../assets/images/ic_sort_icon.svg) no-repeat;
      }
    }
    .draggable-container {
      position: relative;
      .placeholder-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: -3;
        .single-placeholder {
          background-color: $xxlight-gray;
          display: flex;
          justify-content: center;
          align-items: center;
          .placeholder {
            background-color: #fff;
            border: 2px solid $xlight-gray;
            border-radius: 4px;
            padding: 0.75rem;
            width: 90%;
            p {
              text-align: center;
              color: $light-gray;
              font-size: 1rem;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .library-episodes {
    .container {
      width: 100%;
      .top-bar {
        margin: 35px 32px !important;
      }
    }
  }
}
@media (max-width: 576px) {
  .library-episodes {
    .container {
      .top-bar {
        margin:48px 35px 20px 35px !important;
        p {
          font-size: 18px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/user_library/Episodes.vue